import { Icon } from "@iconify/react";
import i18n from "../i18n/i18n";
import { sequenceWithInterval } from "./commonFunctions";


export let navigate = {
  PREVIOUS: 'PREV',
  NEXT: 'NEXT',
  TODAY: 'TODAY',
  DATE: 'DATE',
}

export let views = {
  MONTH: 'month',
  WEEK: 'week',
  WORK_WEEK: 'work_week',
  DAY: 'day',
  AGENDA: 'agenda',
}

export const StorageKeys = {
  LOGGED_USER_UUID: 'logged_user_uuid',
  LOGGED_USER_ID: 'logged_user_id',
  LOGGED_MED_CENTER_ID: 'logged_med_center_id',
  LOGGED_USER_TYPE: 'logged_user_type',
  LOGGED_USER_NAME: 'logged_user_name',
  OWNER_OF_LOGGED_MC_UUID: 'owner_of_logged_mc_uuid',
  OWNER_OF_LOGGED_MC_ID: 'owner_of_logged_mc_id',
  REFERENCE_KEY: 'reference_key',
  LOGGED_USER_ICONOPEE_SESSIONID: 'icanopee_session_id'
}

export const UserList = {
  "1": 'administrateur',
  "2": 'secretariat',
  "3": 'secretaire',
  "4": 'medecin',
  "5": 'patient',
  "7": 'telesecretary',
  'administrateur': "1",
  'secretariat': "2",
  'secretaire': "3",
  'medecin': "4",
  'patient': "5",
  "telesecretary": "7"
}

const ConfigDevUser = {
  'patient': {
    MediCenterId: '1,69,74,79,119,136,139,511',
    LoggedUserUUID: 'de9b4e8f-a7d7-46fc-8e41-f058b243bd5b',
    LoggedUserID: 16706,
    LoggedUserType: UserList[5],
    LoggedUserTypeInt: UserList.patient,
    LoggedUserName: 'Han So Hee',
    ReferenceKey: '17107|z4oZos7jYoVCuS6LrbqIMv5b1dszT7h2BeEQXkK3',
    OwnerOfLoggedMcUUID: '338cc9ee-bfe4-4e94-be71-03ca95e7c3b1',
    OwnerOfLoggedMcID: 2855,
    LoggedUserIconopeeSessionId: '{8463F81A-E640-4B02-8BA8-F0A7660ECD58}'
  },
  'doctor': {
    MediCenterId: 139,
    LoggedUserUUID: '338cc9ee-bfe4-4e94-be71-03ca95e7c3b1',
    LoggedUserID: 2855,
    LoggedUserType: UserList[4],
    LoggedUserTypeInt: UserList.medecin,
    LoggedUserName: 'Park Seo Joon',
    ReferenceKey: '19415|3PRZLnSljIKPS7aQ0L5tAXAbakMtMbEwoRWJ4R9X262f4080',
    OwnerOfLoggedMcUUID: '338cc9ee-bfe4-4e94-be71-03ca95e7c3b1',
    OwnerOfLoggedMcID: 2855,
    LoggedUserIconopeeSessionId: '{40A493AA-F330-4AFB-9A8D-69A1D0A8B2E2}'
  },
  'telesecretary': {
    MediCenterId: 139,
    LoggedUserUUID: '881010d0-1d65-44dc-8e3a-e533c746c08b',
    LoggedUserID: 16893,
    LoggedUserType: UserList[7],
    LoggedUserTypeInt: UserList.telesecretary,
    LoggedUserName: 'Park Seo Joon',
    ReferenceKey: '19239|CLFpYS1g4FpvqX3tvrQp7kymNltsav0uKNSGsHa9e4069999',
    OwnerOfLoggedMcUUID: '338cc9ee-bfe4-4e94-be71-03ca95e7c3b1',
    OwnerOfLoggedMcID: 2855,
    LoggedUserIconopeeSessionId: '{8463F81A-E640-4B02-8BA8-F0A7660ECD58}'
  }
}
// Patient URL -> http://localhost:3000/medicallink/patient/de9b4e8f-a7d7-46fc-8e41-f058b243bd5b/appointment-list
// Doctor URL -> http://localhost:3000/medicallink/medecin/338cc9ee-bfe4-4e94-be71-03ca95e7c3b1/calendar-appointment

const DevUser = {}

export const GetAdminUserId = () => {
  const id = 0
  return id
}

export const GetMediCenterId = () => {
  return sessionStorage.getItem(StorageKeys.LOGGED_MED_CENTER_ID) || DevUser.MediCenterId
}

export const GetLoggedUserUUID = (optional = false) => {
  return optional ? sessionStorage.getItem(StorageKeys.LOGGED_USER_UUID) : sessionStorage.getItem(StorageKeys.LOGGED_USER_UUID) || DevUser.LoggedUserUUID
}

export const GetLoggedUserID = (optional = false) => {
  return optional ? sessionStorage.getItem(StorageKeys.LOGGED_USER_ID) : sessionStorage.getItem(StorageKeys.LOGGED_USER_ID) || DevUser.LoggedUserID
}

export const GetOwnerOfLoggedMcUUID = () => {
  return sessionStorage.getItem(StorageKeys.OWNER_OF_LOGGED_MC_UUID) || DevUser.OwnerOfLoggedMcUUID
}

export const GetOwnerOfLoggedMcID = () => {
  return sessionStorage.getItem(StorageKeys.OWNER_OF_LOGGED_MC_ID) || DevUser.OwnerOfLoggedMcID
}

export const GetCurrentUserType = () => {
  return UserList[sessionStorage.getItem(StorageKeys.LOGGED_USER_TYPE)] || DevUser.LoggedUserType
}

export const GetCurrentUserTypeInt = (optional = false) => {
  return optional ? sessionStorage.getItem(StorageKeys.LOGGED_USER_TYPE) : sessionStorage.getItem(StorageKeys.LOGGED_USER_TYPE) || DevUser.LoggedUserTypeInt
}

export const GetCurrentUserName = () => {
  return sessionStorage.getItem(StorageKeys.LOGGED_USER_NAME) || DevUser.LoggedUserName
}

export const GetReferenceKey = () => {
  return sessionStorage.getItem(StorageKeys.REFERENCE_KEY) || DevUser.ReferenceKey
}

export const GetLoggedUserIconopeeSessionId = () => {
  return sessionStorage.getItem(StorageKeys.LOGGED_USER_ICONOPEE_SESSIONID) || DevUser.LoggedUserIconopeeSessionId
}

export const UserListText = {
  "1": i18n.t('administrator'),
  "2": i18n.t("secretariat"),
  "3": i18n.t('secretary'),
  "4": i18n.t('doctor'),
  "5": i18n.t('patient'),
  "7": i18n.t('telesecretary'),
}

export const SubRootID = "calendar-sub-root";

export const DevPath = ''

export const DetailURL = window.location.origin + `${DevPath}/${GetCurrentUserType()}/${GetLoggedUserUUID()}/patient/detail/`
const doctorEndPoint = `${DevPath}/${GetCurrentUserType()}/${GetLoggedUserUUID()}/calendar-appointment`
const patientEndPoint = `${DevPath}`
const patAppointmentFlowPath = GetLoggedUserID() ? `${patientEndPoint}/${GetCurrentUserType()}/${GetLoggedUserUUID()}` : patientEndPoint

export const AppNav = { // If ever there is a change in the URL structure, change here -> Landing.js, PatientDetail.js, RightComponent.js
  calendar: `${doctorEndPoint}`,
  settings: `${doctorEndPoint}/settings`,
  createAgenda: `${doctorEndPoint}/create-agenda`,
  agendaList: `${doctorEndPoint}/agenda-list`,
  doctorAptActionsList: `${doctorEndPoint}/doctor-apt-actions-list`,
  meeting: `${DevPath}/${GetCurrentUserType()}/${GetLoggedUserUUID()}/meeting`, // need to check
  patient: `${patientEndPoint}/patient/${GetLoggedUserUUID()}/appointment-list`,
  patientAppointment: `${patAppointmentFlowPath}/create-appointment`,
  patientAppointmentLoggedIn: `${patientEndPoint}/${GetLoggedUserUUID()}/create-appointment`,
  patientSelectDoctor: `${patAppointmentFlowPath}/create-appointment/select-doctor`,
  medicalInfo: `${patAppointmentFlowPath}/profile/medicalcenter-profile`,
  doctorInfo: `${patAppointmentFlowPath}/profile/doctor-profile`,
  createUser: `${window.location.origin}${DevPath}/${GetCurrentUserType()}/${GetLoggedUserUUID()}/creer-utilisateur`,
  listUsers: `${window.location.origin}${DevPath}/user-list-api`,
  patientDetails: `${DevPath}/${GetCurrentUserType()}/${GetLoggedUserUUID()}/patient/detail`,
  patientDossierDetails: `${DevPath}/${GetCurrentUserType()}/${GetLoggedUserUUID()}/patient/dossier`,
  researchDoctorInfo: `${patientEndPoint}/profile/research-doctor-info`,

}
// local '/react/' 
// demo and live "/resources/calendar/react/"

export const SubPath = DevPath + '/resources/calendar/react/'
// demo window.location.origin + SubPath
// local SubPath
export const MainPath = SubPath
export const Images = {
  delete: MainPath + "delete.svg",
  edit: MainPath + "edit.svg",
  drag: MainPath + "drag.svg",
  setting: MainPath + "settings.svg",
  secretary: MainPath + "secretary.png",
  patientDefault: MainPath + "patient.png",
  banner: MainPath + "banner-img.png",
  user: MainPath + "user.png",
  visa: MainPath + "visa.png",
  mastercard: MainPath + "mastercard.png",
  rightBG: MainPath + "right-bg.png",
  success: MainPath + "success.png",
  defaultDoctor: MainPath + "default_doctor.png",
  waiting_for_confirmation: MainPath + "01.svg",
  confirmed: MainPath + "09.svg",
  to_advance: MainPath + "12.svg",
  delay: MainPath + "05.svg",
  arrived: MainPath + "02.svg",
  in_progress: MainPath + "02.svg",
  finished: MainPath + "03.svg",
  paid: MainPath + "08.svg",
  unjustified_absence: MainPath + "06.svg",
  cancel_by_patient: MainPath + "10.svg",
  to_postpone_to_prevent: MainPath + "07.svg",
  to_be_postponed_forewarned: MainPath + "11.svg",
  current_location: MainPath + "current_location.svg",
  grey_marker: MainPath + "l0.png",
  blue_marker: MainPath + "l1.png",
  no_person: MainPath + "noperson.png",
  ic_card_cheque: MainPath + "ic_card_cheque.png",
  ic_card_vitale: MainPath + "ic_card_vitale.png",
  ic_card_blue: MainPath + "ic_card_blue.png",
  ic_card_cash: MainPath + "ic_card_cash.png",
  no_agenda_appointment: MainPath + "no_agenda_appointment.png",
  patient_appointment: MainPath + "patient_appointment.png",
  default_consultation: MainPath + "default_consultation.png",
  slot_absence: MainPath + "slot_absence.png",
  day_absence: MainPath + "day_absence.png",
  multi_day_absence: MainPath + "multi_day_absence.png",
  mark_absent: MainPath + "mark_absent.png",
  mark_urgent: MainPath + "mark_urgent.png",
  mark_pause: MainPath + "mark_pause.png",
  message_settings: MainPath + "message_settings.png",
  message_sent: MainPath + "message_sent.png",
  date_grill: MainPath + "date_grill.svg",
  rdv_find: MainPath + "rdv_find.png",
  email_warn: MainPath + "email_warn.png",
}

export const DefaultProfileImages = {
  '2': Images.secretary,
  '3': Images.secretary,
  '4': Images.defaultDoctor,
  '5': Images.patientDefault,
  '7': Images.secretary,
}

export const AppMenu = {
  [`${i18n.t("agenda")},back`]: [],
  [`${i18n.t("settings")},title`]: [
    `${i18n.t("consultation_locations")},01`,
    // `${i18n.t("agenda")},04`,
    {
      [i18n.t("categories")]: [
        `${i18n.t("categories")},02`,
        `${i18n.t("reasons_for_consultation")},03`
      ]
    },
    // `${'Create and Join'},06`
    // `${i18n.t("settings")},05`
  ]
}

export const AgendaCreateMenu = [
  {
    title: i18n.t('configuration'),
    navCode: '01'
  },
  {
    title: i18n.t('category'),
    navCode: '02'
  },
  {
    title: i18n.t('hours_of_operation'),
    navCode: '03'
  },
  {
    title: i18n.t('opening_ranges_calendar'),
    navCode: '04'
  },
  {
    title: i18n.t('access_rights'),
    navCode: '05'
  },
]

const AppointmentStatusView = ({ image: Item, label, imgStyle, divStyle }) => (
  <div className="d-flex gap-2 align-items-center" style={{ flex: 'none' }}>
    <i className="action-icon">{Item}</i>
    <div children={label} />
  </div >
)

export const Colors = {
  primary: "#30416f",
  primaryBlue: 'rgb(232, 245, 255)',
  primaryHover: "#0079D9",
  white: "#ffffff",
  black: "#000000",
  textColor: "#66757F",
  textSubColor: "#667B89",
  formFieldColor: "#f9f9f9",
  formBorder: "#CCD3D8",
  siteBlack: "#263238",
  darkBlack: "#001612",
  yellowBG: "#FFC700",
  cardTxt: "#455A64",
  cardBrd: "#e6e8e9",
  delColor: "#EA3640",
  errColor: "#FF4234",
  tableBG: "#E1E8EB",
  tableTH: "#00233A",
  lightblue: "#d5dff3",
  bannerBDR: "#E5EAEE",
  accordionBG: "rgba(204, 211, 216, 0.10)",
  labelText: "#384248",
  labelBG: "#b6cddb",
  hoverBG: "#DDF3FF",
  calHeadBG: "#C7D0D4",
  calBDR: "#E5E9EB",
  calText: "#333",
  greenBG: "#35B5D3",
  pinkColor: "#C20FBB",
  disableBG: "#F1F4F5",
  codeBG: "#E9F5FE",
  iconBG: "#F3F5F6",
  gridBG: "#EFF4F6",
  tableTitle: "#99A7B0",
  redBGColor: "#FF4F4F",
  redColor: "#F00",
  tagBG: "#00457120",
  mediaBG: "#D2E6F4",
  imgBG: "#D9D9D9",
  subHeadColor: "rgba(209, 234, 251, 1)",
  success: "#198754",
  greyOpac: 'rgba(128, 128, 128, 0.3)',
  urgentColor: "#FF2400",
  absenceColor: '#ff8c00',
  pauseColor: "#ECD347"
}

export const BlockAppointmentStatus = [
  7, 8, 10
]

export const AppointmentStatus = [
  {
    color: '#FCEDAB',
    name: i18n.t('waiting_for_confirmation'),
    item: <AppointmentStatusView image={<Icon icon="gg:sand-clock" style={{ color: Colors.primary }} />} label={i18n.t('waiting_for_confirmation')} />,
    CODE: 'RDV_ATT_CON',
    code: 1,
    params: { main: 'action' }
  },
  {
    color: '#BBDAF0',
    name: i18n.t('confirmed'),
    patientName: i18n.t("apt_confirm"),
    item: <AppointmentStatusView image={<Icon icon="line-md:circle-to-confirm-circle-transition" style={{ color: Colors.primary }} />} label={i18n.t('confirmed')} />,
    CODE: 'RDV_CON',
    code: 2,
    params: { main: 'action' }
  },
  {
    color: '#DDD3FD',
    name: i18n.t('waiting_list'),
    item: <AppointmentStatusView image={<Icon icon="ri:arrow-left-double-line" style={{ color: Colors.primary }} />} label={i18n.t('waiting_list')} />,
    CODE: 'RDV_AVA',
    code: 3,
    params: { main: 'action' }
  },
  {
    color: '#D9AAD7',
    name: i18n.t('delay'),
    patientName: i18n.t("apt_late"),
    item: <AppointmentStatusView image={<Icon icon="formkit:time" style={{ color: Colors.primary }} />} label={i18n.t('delay')} />,
    CODE: 'RDV_RET',
    code: 4,
    params: { main: 'action' }
  },
  {
    color: '#0099cc',
    name: i18n.t('arrived'),
    item: <AppointmentStatusView image={<Icon icon="ion:play-outline" style={{ color: Colors.primary }} />} label={i18n.t('arrived')} />,
    CODE: 'RDV_ARR',
    code: 5,
    params: { main: 'action' }
  },
  {
    color: '#F9D6A6',
    name: i18n.t('in_progress'),
    item: <AppointmentStatusView image={<Icon icon="ion:play-outline" style={{ color: Colors.primary }} />} label={i18n.t('in_progress')} />,
    CODE: 'RDV_EN_COU',
    code: 6,
    params: { main: 'action' }
  },
  {  // Null item for space
    color: '#ff00ff',
    name: i18n.t('arrived'), item: null
  },
  {
    status: true,
    color: '#AAB3D9',
    name: i18n.t('switch_tele'),
    patientName: i18n.t("apt_tele"),
    item: <AppointmentStatusView image={<Icon icon="octicon:device-camera-video-16" style={{ color: Colors.primary }} />} label={i18n.t('switch_tele')} />,
    CODE: 'RDV_PASS_TELECONS',
    code: 9,
    params: { main: 'action' },
    textColor: '#5d6db3'
  },
  {
    color: '#C2E2C2',
    name: i18n.t('to_be_moved'),
    item: <AppointmentStatusView image={<Icon icon="mdi:movie-edit-outline" style={{ color: Colors.primary }} />} label={i18n.t('to_be_moved')} />,
    CODE: 'RDV_DEP',
    params: { main: 'action' },
    code: 11,
  },
  {
    color: '#C2E2C2',
    name: i18n.t('finished'),
    patientName: i18n.t("apt_finish"),
    item: <AppointmentStatusView image={<Icon icon="line-md:circle-to-confirm-circle-transition" style={{ color: '#00ad6f' }} />} label={i18n.t('finished')} />,
    CODE: 'RDV_TER',
    code: 12,
    params: { main: 'action' }
  },
  // {
  //   color: '#ff00ff',
  //   name: i18n.t('paid'),
  //   item: <AppointmentStatusView image={<Icon icon="material-symbols:euro" style={{ color: '#00ad6f' }} />} label={i18n.t('paid')} />,
  //   CODE: 'PAID',
  //   code: 12
  // },
  {  // Null item for space
    color: '#ff00ff',
    name: i18n.t('arrived'), item: null
  },
  {
    color: '#ff8888',
    name: i18n.t('delete'),
    item: <AppointmentStatusView image={<Icon icon="maki:cross" style={{ color: 'red' }} />} label={i18n.t('delete')} />,
    CODE: 'RDV_DEL',
    code: 0,
    params: { main: 'action' }
  },
  {
    color: '#FF6247',
    name: i18n.t('unjustified_absence'),
    patientName: i18n.t("apt_cancel"),
    item: <AppointmentStatusView image={<Icon icon="lets-icons:cancel" style={{ color: 'red' }} />} label={i18n.t('unjustified_absence')} />,
    CODE: 'RDV_ABS_NONJUS',
    code: 7,
    params: { main: 'action' }
  },
  {
    color: '#9D0002',
    name: i18n.t('cancel_doctor'),
    patientName: i18n.t("apt_cancel"),
    item: <AppointmentStatusView image={<Icon icon="lets-icons:cancel" style={{ color: 'black' }} />} label={i18n.t('cancel_doctor')} />,
    CODE: 'RDV_CAN_BY_MED',
    code: 10,
    params: { main: 'action' }
  },
  {
    color: '#F58D8E',
    name: i18n.t('cancel_by_patient'),
    patientName: i18n.t("apt_cancel"),
    item: <AppointmentStatusView image={<Icon icon="lets-icons:cancel" style={{ color: 'black' }} />} label={i18n.t('cancel_by_patient')} />,
    CODE: 'RDV_CAN',
    code: 8,
    params: { main: 'action' }
  }
]

export const OtherStatusViews = [
  {
    color: 'black',
    name: i18n.t('blocked'),
    item: <AppointmentStatusView image={null} label={i18n.t('blocked')} />,
    CODE: 'RDV_PAT_BLOCK',
    code: 13,
    params: { main: 'action' }
  },
  {
    color: '#C2E2C2',
    name: i18n.t('paid'),
    item: <AppointmentStatusView image={null} label={i18n.t('paid')} />,
    CODE: 'RDV_FACTURE_PAID',
    code: 14,
    params: { main: 'action' }
  },
  {
    color: '#ff8888',
    name: i18n.t('payment_failed'),
    item: <AppointmentStatusView image={null} label={i18n.t('payment_failed')} />,
    CODE: 'RDV_FACTURE_NOT_PAID',
    code: 15,
    params: { main: 'action' }
  },

]

export const OnlineBookers = [
  {
    id: -1,
    value: i18n.t("All"),
  },
  {
    id: 1,
    value: i18n.t("myself"),
    color: "#81D2E5"
  },
  {
    id: 2,
    value: i18n.t("doctors"),
    color: "#F6F291"
  },
  {
    id: 3,
    value: i18n.t("patients"),
    color: "#AAFCC1"
  },
  {
    id: 4,
    value: i18n.t("Secretariat"),
    color: "#FFAEFC"
  }
]


export const AppointmentFilterModes = [  //  Don't change the order here
  i18n.t('All'),
  i18n.t('upcoming_appointments'),
  i18n.t('past_appointments'),
  i18n.t('teleconsultation_invitation')
]

export const EmailValidate = (email = '') => (email == '' ? true : (/\b[\w\.-]+@[\w\.-]+\.\w{2,4}\b/).test(email))

export const AppointmentAction = [
  // {
  //   item: <><div className='actiondd-item'><img src={Images.secretary} /><span className='dd-item' children={i18n.t("assigner_to_Secretary")} /></div></>,
  //   code: 1
  // },
  {
    icon: <Icon icon={"ic:baseline-payment"} />,
    title: i18n.t("add_a_price"),
    code: 2
  },
  {
    icon: <Icon icon={"tdesign:attach"} />,
    title: i18n.t("attach_a_document"),
    code: 3
  },
  {
    icon: <Icon icon={"fluent:delete-12-regular"} />,
    title: i18n.t("delete_appointment"),
    code: 4
  }
]

export const AttachOptions = [
  {
    id: 1,
    name: i18n.t("visiable_to_patient")
  },
  {
    id: 2,
    name: i18n.t("visiable_to_me")
  }
]

export const locale = 'fr-FR'


export const ServiceReservationOpen = [
  {
    id: 3,
    value: `3 ${i18n.t("months")} `
  },
  {
    id: 2,
    value: `2 ${i18n.t("months")} `
  },
  {
    id: 1,
    value: `1 ${i18n.t("months")} `
  }
]

export const ServiceReservationClose = [
  {
    id: 1,
    value: `1 ${i18n.t("hour")} `
  },
  {
    id: 2,
    value: `2 ${i18n.t("hours")} `
  },
  {
    id: 3,
    value: `3 ${i18n.t("hours")} `
  },
  {
    id: 4,
    value: `4 ${i18n.t("hours")} `
  }
]

export const ServiceDuration = Array(12).fill(true).map((data, index) => ({
  id: (index + 1) * 5,
  value: `${(index + 1) * 5} ${i18n.t('minutes')}`
}))

export const ServiceConsultationType = [
  {
    id: 1,
    value: i18n.t("in_office"),
    component: (
      <Icon icon="fontisto:hospital" className="react primary-color ms-1" />
    )

  },
  {
    id: 2,
    value: i18n.t("in_teleconsultation"),
    component: (
      <Icon icon="mdi:video" className="react primary-color ms-1" />
    )
  },
  {
    id: 3,
    value: i18n.t("at_home"),
    component: (
      <Icon icon="ic:round-home" className="react primary-color ms-1" />
    )
  }
]

export const AptFlowSteps = {
  '-2': 'SelectServiceDoctor',
  '-1': 'SelectAgenda',
  0: 'FindAppointment',
  1: 'SelectCategory',
  2: 'SelectConsultationMode',
  3: 'PickDoctorSlot',
  4: 'PatientInfo',
  5: 'PaymentConfirm',
  'SelectServiceDoctor': -2,
  'SelectAgenda': -1,
  'FindAppointment': 0,
  'SelectCategory': 1,
  'SelectConsultationMode': 2,
  'PickDoctorSlot': 3,
  'PatientInfo': 4,
  'PaymentConfirm': 5
}

export const WeekDays = [
  {
    id: 1,
    name: i18n.t('Monday')
  },
  {
    id: 2,
    name: i18n.t('Tuesday')
  },
  {
    id: 3,
    name: i18n.t('Wednesday')
  },
  {
    id: 4,
    name: i18n.t('Thursday')
  },
  {
    id: 5,
    name: i18n.t('Friday')
  },
  {
    id: 6,
    name: i18n.t('Saturday')
  },
  {
    id: 7,
    name: i18n.t('Sunday')
  },
]

export const EmergencyContactTypes = [
  {
    id: 1,
    value: i18n.t('samu')
  },
  {
    id: 2,
    value: i18n.t('sos_doctor')
  },
  {
    id: 3,
    value: i18n.t('personal_phone')
  },
  {
    id: 4,
    value: i18n.t('direct_phone')
  },
  // {
  //   id: 5,
  //   value: i18n.t('secretariat')
  // },
]

export const AssociationTypes = [
  {
    id: 0,
    text: i18n.t('office')
  },
  {
    id: 1,
    text: i18n.t('medical_center')
  },
  {
    id: 2,
    text: i18n.t('clinic')
  },
  {
    id: 3,
    text: i18n.t('hospital')
  }
]

export const Parking = [
  {
    id: 1,
    text: i18n.t('none')
  },
  {
    id: 2,
    text: i18n.t('available')
  }
]

export const SUPPRESSED_WARNINGS = [
  "A component is changing an uncontrolled input to be controlled.",
  "ReactDOM.render is no longer supported in React 18",
  "Warning: You provided a `checked` prop to a form field without an `onChange` handler"
];

// s-> seconds, m->minutes, h-> hours, d->day, w-> week, mo-> month, y->year
export const DurationOptionsList = (type) => {
  const data = {
    s: {}
  }
  const typeArray = type.split(",")

}

export class AppHour {
  hour = 0
  constructor(hour) {
    if (hour) {
      if (hour instanceof Date) {
        this.hour = hour.getHours()
        return
      }
      switch (hour.toString().includes(":")) {
        case true:
          this.hour = parseInt(this.#convertTimeToHours(hour.toString()))
          break;
        case false:
          this.hour = parseInt(hour.toString())
          break;
      }
    }

  }

  getHour() {
    return this.hour
  }

  getHourString() {
    return this.#formatHour(this.hour)
  }

  #convertTimeToHours(timeString) {
    const [hours, minutes] = timeString.split(":");
    return parseFloat(hours) + parseFloat(minutes) / 60;
  }

  #formatHour(hour) {
    return hour.toString().padStart(2, '0') + ':00';
  }
}

export class Duration {
  static data = { m: { id: 1, name: i18n.t("min") }, h: { id: 2, name: i18n.t("hours") }, d: { id: 3, name: i18n.t("days") }, mon: { id: 4, name: i18n.t("months") } }
  static DurationList = [{ id: 1, name: i18n.t("min") }, { id: 2, name: i18n.t("hours") }, { id: 3, name: i18n.t("days") }, { id: 4, name: i18n.t("months") }]
  static OpenUnitList = [{ id: 2, name: i18n.t("hours") }, { id: 3, name: i18n.t("days") }, { id: 4, name: i18n.t("months") }]
  static CloseUniList = [{ id: 1, name: i18n.t("min") }, { id: 2, name: i18n.t("hours") }, { id: 3, name: i18n.t("days") }]
  duration = null

  constructor(duration, type) {
    let temp = parseFloat(duration)
    if (type) {
      switch (type) {
        case 1:
          temp = temp
          break;
        case 2:
          temp = temp * 60
          break;
        case 3:
          temp = temp * 24 * 60
          break;
        case 4:
          temp = temp * 31 * 24 * 60
          break
      }
    }
    this.duration = temp
  }

  isValid(zeroValid = false) {
    return zeroValid ? (this.duration == 0) || this.duration : this.duration
  }

  toDurationSplit() {
    let time = parseFloat(this.duration)
    if (time < 60) {
      return [parseFloat(time.toFixed(2)), Duration.data["m"].name];
    } else if (time < 1440) {
      let hours = time / 60;
      return [parseFloat(hours.toFixed(2)), Duration.data["h"].name];
    } else if (time < 44640) {
      let days = time / 1440;
      return [parseFloat(days.toFixed(2)), Duration.data['d'].name]
    } else {
      let days = time / 44640;
      return [parseFloat(days.toFixed(2)), Duration.data['mon'].name]
    }
  }

  getSplitId() {
    if (this.duration < 60) {
      return Duration.data.m.id;
    } else if (this.duration < 1440) {
      return Duration.data.h.id;
    } else if (this.duration < 44640) {
      return Duration.data.d.id
    } else {
      return Duration.data.mon.id
    }
  }

}

export const PickerSortedList = [
  {
    id: 0,
    color: '#FCDD7D',
    item: <div className='colors' style={{ backgroundColor: '#FCDD7D' }} />
  },
  {
    id: 1,
    color: '#F9A870',
    item: <div className='colors' style={{ backgroundColor: '#F9A870' }} />
  },
  {
    id: 2,
    color: '#D792BF',
    item: <div className='colors' style={{ backgroundColor: '#D792BF' }} />
  },
  {
    id: 3,
    color: '#9D86BE',
    item: <div className='colors' style={{ backgroundColor: '#9D86BE' }} />
  },
  {
    id: 4,
    color: '#6F85C1',
    item: <div className='colors' style={{ backgroundColor: '#6F85C1' }} />
  },
  {
    id: 5,
    color: '#81D2E5',
    item: <div className='colors' style={{ backgroundColor: '#81D2E5' }} />
  },
  {
    id: 6,
    color: '#60C2B1',
    item: <div className='colors' style={{ backgroundColor: '#60C2B1' }} />
  },
  {
    id: 7,
    color: '#ACD589',
    item: <div className='colors' style={{ backgroundColor: '#ACD589' }} />
  },
  {
    id: 8,
    color: '#D7E37D',
    item: <div className='colors' style={{ backgroundColor: '#D7E37D' }} />
  },

  {
    id: 9,
    color: '#F17B6F',
    item: <div className='colors' style={{ backgroundColor: '#F17B6F' }} />
  },

]

export const SecureKey = {
  googleMapKey: process.env.REACT_APP_MAP_KEY,
  zoomSdkKey: process.env.REACT_APP_ZOOM_SDK_KEY,
  zoomSdkSecret: process.env.REACT_APP_ZOOM_SDK_SECRET,
}

export const MainSettingsRadioOptions = [
  {
    type: 'title',
    uiRequire: {
      label: i18n.t("consult_access")
    }
  },
  {
    type: 'radio',
    apiProp: '1',
    uiRequire: {
      label: i18n.t("accepting_new_patients")
    }
  },
  {
    type: 'radio',
    apiProp: '2',
    uiRequire: {
      label: i18n.t("accept_tele_consultation")
    }
  },
  {
    type: 'age-input',
    apiProp: '3',
    uiRequire: {
      label: i18n.t("minimum_patient_age"),
      ageLabel: 'ans'
    }
  },
  {
    type: 'radio',
    apiProp: '4',
    uiRequire: { label: i18n.t("at_home") }
  },
  {
    type: 'duration',
    apiProp: '5',
    uiRequire: { label: i18n.t("retard_accept_time") }
  },
  {
    type: 'drop-down',
    apiProp: '6',
    uiRequire: {
      label: i18n.t("minimum_slot_duration"),
      checkArray: sequenceWithInterval(60, 5, 'mins', 'object')
    }
  },
  // {
  //   type: 'display_settings',
  // },
  {
    type: 'title',
    uiRequire: {
      label: i18n.t("reservation"),
    }
  },
  {
    type: 'general',
    uiRequire: {
      label: i18n.t("reservation"),
    }
  },
  {
    type: 'title',
    uiConditional: true,
    uiRequire: {
      label: i18n.t("calendar_rights")
    }
  },
  {
    type: 'multiple-radio',
    uiConditional: true,
    apiProp: 'accessRightAllowSwitch',
    uiRequire: {
      label: i18n.t("want_user_rights_for_this_calendar"),
      radioArray: [
        i18n.t("yes"),
        i18n.t("No"),
      ]
    }
  },
  // {
  //   type: 'drop-down',
  //   uiRequire: {
  //     label: i18n.t("same_rights_calendar"),
  //     checkArray: [
  //       i18n.t("no_access"),
  //       i18n.t("making_and_cancellation_of_appointments"),
  //       i18n.t("opening_closing_time_slots"),
  //       i18n.t("view_only")
  //     ]
  //   }
  // },
  // {
  //   type: 'check-box',
  //   uiRequire: {
  //     label: i18n.t("days_display_week"),
  //     checkArray: [i18n.t("Mon"), i18n.t("Tues"), i18n.t("Wednes"), i18n.t("Thurs"), i18n.t("Fri"), i18n.t("Satur"), i18n.t("Sun")]
  //   }
  // },
  // {
  //   type: 'array-drop-down',
  //   uiRequire: {
  //     label: i18n.t("days_display_week"),
  //     checkArray: [{
  //       name: i18n.t("of"),
  //       dropDownArray: []
  //     },
  //     {
  //       name: i18n.t("of"),
  //       dropDownArray: []
  //     },
  //     {
  //       name: i18n.t("of"),
  //       dropDownArray: []
  //     }]
  //   }
  // },
  // {
  //   type: 'drop-down',
  //   uiRequire: {
  //     label: i18n.t("days_display_week"),
  //     checkArray: [i18n.t("Mon"), i18n.t("Tues"), i18n.t("Wednes"), i18n.t("Thurs"), i18n.t("Fri"), i18n.t("Satur"), i18n.t("Sun")]
  //   }
  // },


]

export const ConsultationScreenType = {
  'Settings': 1,
  'CreateAgenda': 2,
}

export const AccessObj = {
  1: i18n.t("no_access"),
  2: i18n.t("read_only"),
  3: i18n.t("appointment_create"),
  5: i18n.t("appointment_management"),
  4: i18n.t("opening_closing_time_slots"),
  6: i18n.t("apt_mng_message"),
  7: i18n.t("apt_mng_dossier"),
  no_access: 1,
  read_only: 2,
  only_create: 3,
  manage_apt: 5,
  full_access: 4,
  apt_mng_message: 6,
  apt_mng_dossier: 7
}

export const AccessArray = [
  { id: AccessObj.no_access, name: AccessObj[1] },
  { id: AccessObj.read_only, name: AccessObj[2] },
  { id: AccessObj.only_create, name: AccessObj[3] },
  { id: AccessObj.manage_apt, name: AccessObj[5] },
  { id: AccessObj.full_access, name: AccessObj[4] },
]

export const TeleSecAccessArray = [
  { id: AccessObj.no_access, name: AccessObj[1] },
  { id: AccessObj.read_only, name: AccessObj[2] },
  { id: AccessObj.only_create, name: AccessObj[3] },
  { id: AccessObj.apt_mng_message, name: AccessObj[6] },
  { id: AccessObj.apt_mng_dossier, name: AccessObj[7] },
]

export const DoctorTitle = {
  1: 'Dr',
  2: 'Pr'
}
export const PatientTitle = {
  1: 'Mr',
  2: 'Mme',
  3: 'Mlle',
  4: 'Enfant'
}

export const getUserTitle = (userType, titleId) => {
  switch (userType) {
    case 2:
      return 'Sec'
    case 3:
      return 'Sec'
    case 4:
      if (titleId == 1 || titleId == 2) return DoctorTitle[titleId]
      else return DoctorTitle[1]
    case 5:
      if (titleId >= 1 && titleId <= 4) return PatientTitle[titleId]
      else return 'Pat'
    case 7:
      return 'TeleSec'
    default:
      return ''
  }
}

export const BasicValidate = (data) => {
  if (typeof data != 'object' || Array.isArray(data)) {
    return false
  }

  return Object.entries(data).every((value) => {
    switch (typeof value[1]) {
      case 'string':
      case 'number':
        return value[1].toString()
      case 'object':
        if (Array.isArray(value[1])) {
          return value[1][0]
        }
        return true;
      default:
        return value[1]
    }
  })
}

export const agendaGroup = [
  { id: 1, name: i18n.t("none") },
  { id: 2, name: i18n.t("location") },
  { id: 3, name: i18n.t("speciality") },
]
export const Messages = {
  API_MESSAGE_USER_CREATED: 'api_message_user_created',
  API_MESSAGE_USER_LOGGED: 'API_MESSAGE_USER_LOGGED'
}

export const PersistResetVersion = 1.0

export const PaymentModes = {
  1: { name: 'Chèques', image: Images.ic_card_cheque },
  2: { name: 'Espèces', image: Images.ic_card_cash },
  3: { name: 'Carte Bancaire', image: Images.ic_card_blue }
}

export const ServiceReservation = [
  { id: '1', nom: 'Patients' },
  { id: '2', nom: 'Secrétaire' },
  { id: '3', nom: 'Docteur' },
]

export const PaymentSecuers = {
  1: { name: 'Conventionné secteur 1' },
  2: { name: 'Conventionné secteur 1 avec droit permanent à dépassement' },
  3: { name: 'Conventionné secteur 2 sans OPTAM' },
  4: { name: 'Conventionné secteur 1 avec OPTAM' },
  5: { name: 'Conventionné secteur 2 avec OPTAM' },
  6: { name: 'Conventionné secteur 1 avec OPTAM - CO' },
  7: { name: 'Conventionné secteur 2 avec OPTAM - CO' },
  8: { name: 'Secteur 3(non - conventionné)' }
}
export const DaySlotStatus = [ // on removal of item change 'id'(in sequential order and always starts with 1) too 
  // {
  //   id: 1,
  //   text: 'Pause de petit-déjeuner'
  // },
  {
    id: 1,
    text: 'Pause déjeuner'
  },
  {
    id: 2,
    text: 'Consultation'
  },
  // {
  //   id: 4,
  //   text: 'Stop RDV'
  // },
  {
    id: 3,
    text: 'Pas de RDV'
  },
  // {
  //   id: 4,
  //   text: 'Consultation'
  // }
]

export const ConsulationModes = {
  in_office: { id: 1, name: i18n.t('in_office') },
  in_teleconsultation: { id: 2, name: i18n.t('in_teleconsultation') },
  at_home: { id: 3, name: i18n.t('at_home') }
}

export function sortByParamName(arrayOfObjects, paramName) {
  // Check if the array is empty or null
  if (!arrayOfObjects || arrayOfObjects.length === 0) {
    return [];
  }

  // Check if the parameter name is valid
  if (!paramName || typeof paramName !== 'string') {
    throw new Error('Invalid parameter name');
  }

  // Sort the array of objects based on the specified parameter name
  const sortedArray = arrayOfObjects.sort((a, b) => {
    const valueA = (a[paramName] || '').toString().toLowerCase();
    const valueB = (b[paramName] || '').toString().toLowerCase();

    // Check if the values are comparable
    if (valueA === undefined || valueB === undefined) {
      throw new Error(`Parameter '${paramName}' not found in some objects`);
    }

    // Compare values
    if (valueA < valueB) {
      return -1;
    }
    if (valueA > valueB) {
      return 1;
    }
    return 0;
  });

  // Extract values based on the sorted order
  const sortedValues = sortedArray

  return sortedValues;
}

export const landingLocalStorageKey = 'landing_search'
export const patientAppointment = 'patientAppointment'

export const getLocalization = () => {
  const localisation = document.querySelector('meta[name="localization"]')?.getAttribute?.('content')
  // console.log('localization', localisation);
  return localisation || "fr"
}

export const milliSecondsToMinutes = (milliSec) => {
  if (typeof milliSec != 'number') {
    console.log('Milliseconds convertion error');
    return 0
  }
  return milliSec / 60000
}

export const minutesToMilliSeconds = (secs) => {
  if (typeof secs != 'number') {
    console.log('Seconds convertion error');
    return 0
  }
  return secs * 60000
}

export const AbsenceReasons = [
  { id: 1, value: i18n.t('leave') },
  { id: 2, value: i18n.t('sick_leave') },
  { id: 3, value: i18n.t('training') },
  { id: 4, value: i18n.t('emergencies') },
  { id: 5, value: i18n.t('other') }
]
export const AbsenceModes = [ // Do not change the order here
  { id: 1, value: i18n.t('mark_absent_slot'), image: Images.mark_absent, title: i18n.t('place_absence_time'), mode: 1, color: Colors.absenceColor },
  { id: 3, value: i18n.t('mark_urgent_slot'), image: Images.mark_urgent, title: i18n.t('place_urgent_time'), mode: 3, color: Colors.urgentColor },
  { id: 2, value: i18n.t('mark_pause_slot'), image: Images.mark_pause, title: i18n.t('place_break_time'), mode: 2, color: Colors.pauseColor },
  { id: 4, value: i18n.t('send_message_to_patients'), image: Images.message_settings, title: i18n.t('send_message_to_patients'), mode: 4, color: Colors.greenBG },
]
export const AbsenceModeOBJ = {
  '1': { value: i18n.t('mark_absent_slot'), image: Images.mark_absent, title: i18n.t('place_absence_time'), mode: 1, color: Colors.absenceColor, label: i18n.t('absence'), deletiontxt: i18n.t('delete_absence') },
  '2': { value: i18n.t('mark_pause_slot'), image: Images.mark_pause, title: i18n.t('place_break_time'), mode: 2, color: Colors.pauseColor, label: i18n.t('pause'), deletiontxt: i18n.t('delete_pause') },
  '3': { value: i18n.t('mark_urgent_slot'), image: Images.mark_urgent, title: i18n.t('place_urgent_time'), mode: 3, color: Colors.urgentColor, label: i18n.t('urgent'), deletiontxt: i18n.t('delete_urgent') },
}

export const PatientAppointmentHistory = [
  {
    id: 1,
    name: i18n.t('honored'),
    key: 'RDV_TER'
  },
  {
    id: 2,
    name: i18n.t('future'),
    key: 'RDV_UP_COM'
  },
  {
    id: 3,
    name: i18n.t('absent'),
    key: 'RDV_ABS_NONJUS'
  },
  {
    id: 4,
    name: i18n.t('cancelled'),
    key: 'RDV_CAN'
  },
  {
    id: 5,
    name: i18n.t('deleted'),
    key: 'RDV_DEL'
  }
]

export const MaxTextAreaLength = 250

export function objectToFormData(obj, form, formArray = true) {
  const fd = form || new FormData();

  for (let property in obj) {
    if (obj.hasOwnProperty(property)) {
      const value = obj[property];

      if (Array.isArray(value)) {
        // If the value is an array, append each item individually
        if (formArray) {
          value.forEach((item, index) => {
            fd.append(`${property}[]`, item);
          });
        }
        else {
          value.forEach((item) => {
            const splitItems = item?.split(',');
            splitItems.forEach((splitItem) => {
              fd.append(`${property}[]`, splitItem.trim());
            });
          });
        }
      } else {
        // Otherwise, append the value directly
        fd.append(property, value);
      }
    }
  }

  return fd;
}

export const OpeningType = Object.freeze({
  NORMAL: 1,
  URGENT: 2
})

export const OpeningModes = [
  { id: 1, name: i18n.t('normal'), value: OpeningType.NORMAL },
  { id: 2, name: i18n.t('urgent'), value: OpeningType.URGENT }
]

/*
const Redirects = {
  act = 1  => 
  act = 2  => Patient Reconfirm
  act = 3  => Doctor Retard Confirm
  act = 4  => Doctor Retard Reject
  act = 5  => Patient Reschedule after Doctor absence
}
*/

export const Supportive_document = [
  { id: 1, value: 1, label: i18n.t('national_identity_card') },
  { id: 2, value: 2, label: i18n.t('passport') },
  { id: 3, value: 3, label: i18n.t('residence_permit') },
  { id: 4, value: 4, label: i18n.t('eIDAS') },
  { id: 5, value: 5, label: i18n.t('trusted_third_party') },
]

export const RDVTrackTypes = {
  RDV_CREATE: 1,
  RDV_TIME_UPDATE: 2,
  RDV_AGENDA_UPDATE: 3,
  RDV_SERVICE_UPDATE: 4,
  RDV_CONSULTATION_MODE_UPDATE: 5,
  RDV_STATUS_UPDATE: 6,
  RDV_UPDATE: 7,
  RDV_DELETE: 8,
  RDV_FILE_UPLOAD: 9,
  RDV_FILE_REMOVE: 10,
  1: 'RDV_CREATE',
  2: 'RDV_TIME_UPDATE',
  3: 'RDV_AGENDA_UPDATE',
  4: 'RDV_SERVICE_UPDATE',
  5: 'RDV_CONSULTATION_MODE_UPDATE',
  6: 'RDV_STATUS_UPDATE',
  7: 'RDV_UPDATE',
  8: 'RDV_DELETE',
  9: 'RDV_FILE_UPLOAD',
  10: 'RDV_FILE_REMOVE',
}


export const StatusOBJ = {
  0: 'RDV_DEL',
  1: 'RDV_ATT_CON',
  2: 'RDV_CON',
  3: 'RDV_AVA',
  4: 'RDV_RET',
  5: 'RDV_ARR',
  6: 'RDV_EN_COU',
  7: 'RDV_ABS_NONJUS',
  8: 'RDV_CAN',
  9: 'RDV_PASS_TELECONS',
  10: 'RDV_CAN_BY_MED',
  11: 'RDV_DEP',
  12: 'RDV_TER',
  13: 'RDV_PAT_BLOCK',
  14: 'RDV_FACTURE_PAID',
  15: 'RDV_FACTURE_NOT_PAID',
  RDV_DEL: 0,
  RDV_ATT_CON: 1,
  RDV_CON: 2,
  RDV_AVA: 3,
  RDV_RET: 4,
  RDV_ARR: 5,
  RDV_EN_COU: 6,
  RDV_ABS_NONJUS: 7,
  RDV_CAN: 8,
  RDV_PASS_TELECONS: 9,
  RDV_CAN_BY_MED: 10,
  RDV_DEP: 11,
  RDV_TER: 12,
  RDV_PAT_BLOCK: 13,
  RDV_FACTURE_PAID: 14,
  RDV_FACTURE_NOT_PAID: 15
}

/**

'RDV_ATT_CON'=> 1                           -> Attente de confirmation
'RDV_CON'=> 2                                   -> Confirmé
'RDV_AVA'=> 3                                     -> Liste d'attente
'RDV_RET'=> 4                                     -> Retard
'RDV_ARR'=> 5                                     -> Arrivé
'RDV_EN_COU'=> 6                             -> En cours
'RDV_ABS_NONJUS'=> 7                    -> Absence non justifiée
'RDV_CAN'=> 8                                     -> Annulé par le patient
'RDV_PASS_TELECONS'=> 9               -> Passer en téléconsultation
'RDV_CAN_BY_MED'=> 10                   -> Annulé par le médecin
'RDV_DEP'=> 11                                     -> A déplacer
'RDV_TER'=> 12                                     -> Terminé
'RDV_PAT_BLOCK'=> 13                      -> Bloquer le patient
 
'Delete ' => 0                                          -> Supprimer
 */